module.exports = __webpack_public_path__ + "img/L_316_325.9b338678.png";